module.exports = __webpack_public_path__ + "static/media/S (116).72cbeb63.jpg";